import React, { useState } from 'react';
import axios from 'axios';
import { Button, Space } from 'antd';
import {
  func, number, oneOfType, string,
} from 'prop-types';
import { set_current_year_path } from 'js-routes/generated/routes';
import { CalendarIcon, FieldGroupIcon } from 'components/cwo-icons';
import { ChevronLeftColor, ChevronRightColor } from 'components/cwo-icon-pack';
import ButtonWrapper from '../components/toggle-button/nested/ButtonWrapper';
import ButtonContent from '../components/toggle-button/nested/ButtonContent';
import pageReload from '../helpers/pageReload';

const ToggleBtnSeasonAndFieldGroup = ({
  fieldGroupLabel,
  fieldGroupValue,
  loadMenuData,
  seasonLabel,
  seasonValue,
  showDrawer,
}) => {
  const nextSeason = Number(seasonValue) + 1;
  const prevSeason = Number(seasonValue) - 1;

  const [showSeasonSwitcher, setShowSeasonSwitcher] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSwitchSeason = async (e, selectedSeason) => {
    e.stopPropagation();
    setLoading(true);

    try {
      await axios.get(set_current_year_path(selectedSeason));
    } finally {
      pageReload();
    }
  };

  return (
    <ButtonWrapper
      isVisible
      loadMenuData={loadMenuData}
      showDrawer={showDrawer}
      toggleKey="1"
      onMouseMove={() => setShowSeasonSwitcher(true)}
      onMouseLeave={() => setShowSeasonSwitcher(false)}
    >
      <Space size={4}>
        <ButtonContent
          id="season-btn"
          showExpandIcon={false}
          iconBackgroundColor={(showSeasonSwitcher || loading) ? 'transparent' : '#F6F2FE'}
          label={seasonLabel}
          value={seasonValue}
          icon={(showSeasonSwitcher || loading) ? (
            <Button
              loading={loading}
              disabled={loading}
              onClick={(e) => handleSwitchSeason(e, prevSeason)}
              icon={<ChevronLeftColor notUseClass />}
            />
          ) : <CalendarIcon />}
        />
        <ButtonContent
          id="field-groups-btn"
          showExpandIcon
          iconBackgroundColor={(showSeasonSwitcher || loading) ? 'transparent' : '#EAF6FF'}
          label={fieldGroupLabel}
          value={fieldGroupValue}
          icon={(showSeasonSwitcher || loading) ? (
            <Button
              loading={loading}
              disabled={loading}
              onClick={(e) => handleSwitchSeason(e, nextSeason)}
              icon={<ChevronRightColor notUseClass />}
            />
          ) : <FieldGroupIcon />}
        />
      </Space>
    </ButtonWrapper>
  );
};

ToggleBtnSeasonAndFieldGroup.propTypes = {
  showDrawer: func.isRequired,
  loadMenuData: func.isRequired,
  seasonLabel: string.isRequired,
  seasonValue: oneOfType([string, number]).isRequired,
  fieldGroupLabel: string.isRequired,
  fieldGroupValue: oneOfType([string, number]).isRequired,
};

export default ToggleBtnSeasonAndFieldGroup;
